// extracted by mini-css-extract-plugin
export default {"wrapprer":"DefaultLayout_wrapprer__LRtrq","body":"DefaultLayout_body__B0HM3","mobileMenuButton":"DefaultLayout_mobileMenuButton__m1-IO"};